import { render, staticRenderFns } from "./NewFlash.vue?vue&type=template&id=6be64665&scoped=true&"
import script from "./NewFlash.vue?vue&type=script&lang=js&"
export * from "./NewFlash.vue?vue&type=script&lang=js&"
import style0 from "./NewFlash.vue?vue&type=style&index=0&id=6be64665&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be64665",
  null
  
)

export default component.exports